import React, { useState, useEffect } from "react";
import { Dropdown } from "primereact/dropdown";
import { MultiSelect } from "primereact/multiselect";
import { Button } from "primereact/button";

import DataControls from "../../components/DataTools/DataControls";
import { useLanguageContext } from "../../context/GlobalProvider";
import { getLocalStorage } from "../../services/LocalStorage";
import ReportService from "../../services/ReportService";

export default function CustomReport() {
  const { t } = useLanguageContext();
  const [selectedReportName, setSelectedReportrName] = useState(null);

  const [hotelListName, setHotelListName] = useState([]);
  const [selectedHotel, setSelectedHotel] = useState(null);
  const [selectedHotels, setSelectedHotels] = useState([]);

  const [selectedYears, setSelectedYears] = useState(null);
  const [selectedMonth, setSelectedMonth] = useState(null);
  const [selectedFromMonth, setSelectedFromMonth] = useState("01");
  const [selectedToMonth, setSelectedToMonth] = useState("12");

  const [selectedFormat, setSelectedFormat] = useState(null);
  const [isExporting, setIsExporting] = useState(false);
  const groupHotelId = Number(getLocalStorage("groupHotel"));
  const reportNameList = [
    { id: "GL_Extract", name: t("glreportNameListItem_1") },
    {
      id: "GL_Extract_Consolidated_By_Account",
      name: t("glbyAccountreportNameListItem_2"),
    },
    ...(groupHotelId === 9
      ? [{ id: "Budget_Extraction", name: "Budget_Extraction" }]
      : []),
  ];

  const [showHotelIdInput, setShowHotelIdInput] = useState(false);
  const [displayedPrintReportsForm, setDisplayedPrintReportsForm] =
    useState(false);
  const isBudgetExtractionReport = selectedReportName === "Budget_Extraction";

  const monthsList = [
    { id: "1", name: "01" },
    { id: "2", name: "02" },
    { id: "3", name: "03" },
    { id: "4", name: "04" },
    { id: "5", name: "05" },
    { id: "6", name: "06" },
    { id: "7", name: "07" },
    { id: "8", name: "08" },
    { id: "9", name: "09" },
    { id: "10", name: "10" },
    { id: "11", name: "11" },
    { id: "12", name: "12" },
  ];

  const yearsList = [
    { id: "1", name: "2017" },
    { id: "2", name: "2018" },
    { id: "3", name: "2019" },
    { id: "4", name: "2020" },
    { id: "5", name: "2021" },
    { id: "6", name: "2022" },
    { id: "7", name: "2023" },
    { id: "8", name: "2024" },
    { id: "9", name: "2025" },
    { id: "10", name: "2026" },
  ];
  const formatList = [
    { id: "xlsx", name: "excel" },
    { id: "pdf", name: "pdf" },
    { id: "csv", name: "csv" },
  ];
  const budgetExtractionFormatList = [
    { id: "xlsx", name: "excel" },
    { id: "csv", name: "csv" },
  ];

  const selectedHotelTemplate = (option, props) => {
    if (option) {
      return (
        <div className="country-item country-item-value  flex align-items-center">
          <img
            alt={option.name}
            src={`https://app.operandi.travel/images/logos/${option.logo}`}
            style={{ width: "20px", height: "20px" }}
            onError={e =>
              (e.target.src =
                "https://www.primefaces.org/wp-content/uploads/2020/05/placeholder.png")
            }
            className={`border-circle  flag flag-${option.name.toLowerCase()}`}
          />
          <div className="selected-hotel-name">{option.name}</div>
        </div>
      );
    }

    return <span>{props.placeholder}</span>;
  };

  const hotelOptionTemplate = option => {
    return (
      <React.Fragment>
        <div className="country-item  flex align-items-center">
          <img
            alt={option.name}
            src={`https://app.operandi.travel/images/logos/${option.logo}`}
            style={{ width: "17px" }}
            onError={e =>
              (e.target.src =
                "https://www.primefaces.org/wp-content/uploads/2020/05/placeholder.png")
            }
            className={`flag flag-${option.name.toLowerCase()}`}
          />
          <div
            className="hotel-name"
            style={{ marginLeft: "12px", color: option.pilot ? "red" : "" }}
          >
            {option.name}
          </div>
        </div>
      </React.Fragment>
    );
  };

  useEffect(() => {
    const userHotels = getLocalStorage("userHotels") || [];
    const mappedHotels = userHotels.map(item => ({
      id: item.hotelId,
      name: item.name,
      logo: item.logo,
      pilot: item.pilot,
    }));
    setHotelListName(mappedHotels);

    if (mappedHotels.length) {
      setSelectedHotels(mappedHotels.map(item => item.id));
      setSelectedHotel(mappedHotels[0].id);
    }
  }, []);

  useEffect(() => {
    if (selectedReportName === "Budget_Extraction") {
      setShowHotelIdInput(false);
      setDisplayedPrintReportsForm(true);
      setSelectedYears("2026");
      setSelectedFromMonth("01");
      setSelectedToMonth("12");
      setSelectedHotels([]);
      setSelectedHotel(null);
    } else if (
      selectedReportName === "GL_Extract_Consolidated_By_Account" ||
      selectedReportName === "GL_Extract"
    ) {
      setShowHotelIdInput(true);
      setDisplayedPrintReportsForm(true);
      setSelectedFromMonth("01");
      setSelectedToMonth("12");
      setSelectedHotel(hotelListName[0] ? hotelListName[0].id : null);
    } else {
      setShowHotelIdInput(false);
      setDisplayedPrintReportsForm(false);
      setSelectedHotels([]);
      setSelectedHotel(null);
      setSelectedFromMonth("01");
      setSelectedToMonth("12");
      setSelectedMonth(null);
    }
  }, [selectedReportName, hotelListName]);
  useEffect(() => {
    if (selectedReportName === "Budget_Extraction") {
      setSelectedFormat(prev =>
        prev && budgetExtractionFormatList.some(item => item.id === prev)
          ? prev
          : "xlsx",
      );
    }
  }, [selectedReportName]);
  const onHotelChange = e => {
    setSelectedHotel(e.target.value);
  };

  const onYearChange = e => {
    setSelectedYears(e.value);
  };

  const getHotelParamString = () => {
    if (isBudgetExtractionReport) {
      return `Hotel_Id=null`;
    }

    const hotelIds = [selectedHotel];

    if (!hotelIds || hotelIds.length === 0 || !hotelIds[0]) {
      return "Hotel_Id=null";
    }

    return `Hotel_Id=${hotelIds[0]}`;
  };

  const getSelectedMonthRange = () => {
    if (!isBudgetExtractionReport) {
      return { from: selectedMonth, to: selectedMonth };
    }

    const fromMonth = selectedFromMonth || "01";
    const toMonth = selectedToMonth || "12";
    const monthStart = Number(fromMonth);
    const monthEnd = Number(toMonth);

    return {
      from: monthStart <= monthEnd ? fromMonth : toMonth,
      to: monthStart <= monthEnd ? toMonth : fromMonth,
    };
  };

  const buildBudgetExtractionParamString = () => {
    const { from, to } = getSelectedMonthRange();
    const groupHotel = getLocalStorage("groupHotel");
    return `Group_Hotels_Id=${groupHotel};Hotel_Id=null;Bud_Version=V0;Year=${selectedYears};From_Month=${from};End_Month=${to}`;
  };

  function exportPdfReports() {
    const glExtractReportId = "GL_Extract";
    const GlExtractByAccountReportId = "GL_Extract_Consolidated_By_Account";
    let reportParamString = "";
    const groupHotel = getLocalStorage("groupHotel");

    if (selectedReportName === "Budget_Extraction") {
      reportParamString = buildBudgetExtractionParamString();
      ReportService.printPdfReport(
        selectedReportName,
        selectedReportName,
        selectedReportName,
        reportParamString,
        selectedFormat,
      );
      return;
    }

    if (selectedReportName === "GL_Extract") {
      reportParamString += `Group_Hotels_Id=${groupHotel};Hotel_Id=${selectedHotel};Year=${selectedYears};Month=${selectedMonth}`;
      ReportService.printPdfReport(
        selectedReportName,
        "",
        glExtractReportId,
        reportParamString,
        selectedFormat,
      );
    }

    if (selectedReportName === "GL_Extract_Consolidated_By_Account") {
      reportParamString += `Group_Hotels_Id=${groupHotel};Hotel_Id=${selectedHotel};Year=${selectedYears};Month=${selectedMonth}`;
      ReportService.printPdfReport(
        selectedReportName,
        "",
        GlExtractByAccountReportId,
        reportParamString,
        selectedFormat,
      );
    }
  }

  function exportExcelReports() {
    const glExtractReportId = "GL_Extract";
    const GlExtractByAccountReportId = "GL_Extract_Consolidated_By_Account";
    let reportParamString = "";
    const groupHotel = getLocalStorage("groupHotel");

    if (selectedReportName === "Budget_Extraction") {
      reportParamString = buildBudgetExtractionParamString();
      return ReportService.printExcelReport(
        selectedReportName,
        selectedReportName,
        selectedReportName,
        reportParamString,
        selectedFormat,
      );
    }

    if (selectedReportName === "GL_Extract") {
      reportParamString += `Group_Hotels_Id=${groupHotel};Hotel_Id=${selectedHotel};Year=${selectedYears};Month=${selectedMonth}`;
      return ReportService.printExcelReport(
        selectedReportName,
        "",
        glExtractReportId,
        reportParamString,
        selectedFormat,
      );
    }

    if (selectedReportName === "GL_Extract_Consolidated_By_Account") {
      reportParamString += `Group_Hotels_Id=${groupHotel};Hotel_Id=${selectedHotel};Year=${selectedYears};Month=${selectedMonth}`;
      return ReportService.printExcelReport(
        selectedReportName,
        "",
        GlExtractByAccountReportId,
        reportParamString,
        selectedFormat,
      );
    }

    return Promise.resolve();
  }

  function exportCsvReports() {
    const glExtractReportId = "GL_Extract";
    const GlExtractByAccountReportId = "GL_Extract_Consolidated_By_Account";
    let reportParamString = "";
    const groupHotel = getLocalStorage("groupHotel");

    if (selectedReportName === "Budget_Extraction") {
      reportParamString = buildBudgetExtractionParamString();
      return ReportService.printCsvReport(
        selectedReportName,
        selectedReportName,
        selectedReportName,
        reportParamString,
        selectedFormat,
      );
    }

    if (selectedReportName === "GL_Extract") {
      reportParamString += `Group_Hotels_Id=${groupHotel};Hotel_Id=${selectedHotel};Year=${selectedYears};Month=${selectedMonth}`;

      return ReportService.printCsvReport(
        selectedReportName,
        "",
        glExtractReportId,
        reportParamString,
        selectedFormat,
      );
    }

    if (selectedReportName === "GL_Extract_Consolidated_By_Account") {
      reportParamString += `Group_Hotels_Id=${groupHotel};Hotel_Id=${selectedHotel};Year=${selectedYears};Month=${selectedMonth}`;
      return ReportService.printCsvReport(
        selectedReportName,
        "",
        GlExtractByAccountReportId,
        reportParamString,
        selectedFormat,
      );
    }

    return Promise.resolve();
  }

  async function exportReports() {
    if (!selectedFormat || !selectedReportName) {
      return;
    }

    setIsExporting(true);

    try {
      if (selectedFormat === "xlsx") {
        await exportExcelReports();
      }
      if (selectedFormat === "pdf") {
        await exportPdfReports();
      }
      if (selectedFormat === "csv") {
        await exportCsvReports();
      }
    } finally {
      setIsExporting(false);
    }
  }

  return (
    <React.Fragment>
      <DataControls displayedImportExportDataControl="false" />

      <div className="surface-section px-4 py-8 md:px-6 lg:px-8">
        <div className="grid">
          <div className="col-12 md:col-6">
            <div className="p-fluid pr-0 md:pr-6">
              <div className="text-center text-xl font-bold"></div>
              <div className="field mb-3">
                <label htmlFor="reportName" className="font-medium">
                  {t("labelReportNameField")} *
                </label>
                <Dropdown
                  value={selectedReportName}
                  onChange={e => setSelectedReportrName(e.value)}
                  options={reportNameList}
                  optionLabel="name"
                  optionValue="id"
                  placeholder={t("placeholderReportNameField")}
                  inputId="reportName"
                />
              </div>
              {showHotelIdInput ? (
                isBudgetExtractionReport ? (
                  <div className="field mb-3">
                    <label htmlFor="selectedHotels" className="font-medium">
                      {t("labelhotelsField")} *
                    </label>
                    <MultiSelect
                      value={selectedHotels}
                      options={hotelListName}
                      onChange={e => setSelectedHotels(e.value)}
                      optionLabel="name"
                      optionValue="id"
                      placeholder={t("placeholderHotelListField")}
                      filter
                      filterBy="name"
                      maxSelectedLabels={1}
                      inputId="selectedHotels"
                    />
                  </div>
                ) : (
                  <div className="field mb-3">
                    <label htmlFor="selectedHotel" className="font-medium">
                      {t("labelhotelsField")} *
                    </label>
                    <Dropdown
                      placeholder={t("placeholderHotelListField")}
                      valueTemplate={selectedHotelTemplate}
                      itemTemplate={hotelOptionTemplate}
                      value={selectedHotel}
                      options={hotelListName}
                      onChange={onHotelChange}
                      optionLabel="name"
                      optionValue="id"
                      filter
                      filterBy="name"
                      filterMatchMode="startsWith"
                      name="hotelListDropDown"
                      inputId="selectedHotel"
                    ></Dropdown>
                  </div>
                )
              ) : null}

              {displayedPrintReportsForm ? (
                <>
                  <div className="field mb-3 grid formgrid p-fluid">
                    <div className="field mb-4 col-12 md:col-6">
                      <label htmlFor="selectedYears" className="font-medium">
                        {t("labelYearsReportsField")} *
                      </label>
                      <Dropdown
                        value={selectedYears}
                        onChange={onYearChange}
                        options={yearsList}
                        optionLabel="name"
                        optionValue="name"
                        placeholder={t("placeholderSelectYearField")}
                        inputId="selectedYears"
                      />
                    </div>

                    {isBudgetExtractionReport ? (
                      <>
                        <div className="field mb-4 col-12 md:col-3">
                          <label
                            htmlFor="selectedFromMonth"
                            className="font-medium"
                          >
                            {t("labelMonthFromField")} *
                          </label>
                          <Dropdown
                            value={selectedFromMonth}
                            onChange={e => setSelectedFromMonth(e.value)}
                            options={monthsList}
                            optionLabel="name"
                            optionValue="name"
                            placeholder={t("placeholderSelectMonthField")}
                            inputId="selectedFromMonth"
                          />
                        </div>

                        <div className="field mb-4 col-12 md:col-3">
                          <label
                            htmlFor="selectedToMonth"
                            className="font-medium"
                          >
                            {t("labelMonthToField")} *
                          </label>
                          <Dropdown
                            value={selectedToMonth}
                            onChange={e => setSelectedToMonth(e.value)}
                            options={monthsList}
                            optionLabel="name"
                            optionValue="name"
                            placeholder={t("placeholderSelectMonthField")}
                            inputId="selectedToMonth"
                          />
                        </div>
                      </>
                    ) : (
                      <div className="field mb-4 col-12 md:col-6">
                        <label htmlFor="selectedMonth" className="font-medium">
                          {t("labelMonthsReportsfield")} *
                        </label>
                        <Dropdown
                          value={selectedMonth}
                          onChange={e => setSelectedMonth(e.value)}
                          options={monthsList}
                          optionLabel="name"
                          optionValue="name"
                          placeholder={t("placeholderSelectMonthField")}
                          inputId="selectedMonth"
                        />
                      </div>
                    )}
                  </div>

                  <div className="field mb-3">
                    <label htmlFor="selectedFormat" className="font-medium">
                      {t("labelFormatField")} *
                    </label>
                    <Dropdown
                      value={selectedFormat}
                      onChange={e => setSelectedFormat(e.value)}
                      options={
                        isBudgetExtractionReport
                          ? budgetExtractionFormatList
                          : formatList
                      }
                      optionLabel="name"
                      optionValue="id"
                      placeholder={t("placeholderFormatField")}
                      inputId="selectedFormat"
                      disabled={false}
                    />
                  </div>
                </>
              ) : null}
              <Button
                type="submit"
                label={isExporting ? "Exporting..." : t("exportButton")}
                className="w-auto p-button-success"
                onClick={() => exportReports()}
                disabled={isExporting}
                loading={isExporting}
              />
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}
